const message_store = {
    subscribers:{},
    navItemClick(navItem){
        this.publish('NAV-ITEM-CLICK', {navItem:navItem})
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default message_store